class LockedCollectionForm extends window.BAO.CustomElement({
  SuperClass: HTMLFormElement,
}) {
  constructor () {
    super()

    this.state = {
      isLocked: true,
    }
  }

  connectedCallback () {
    this.setupListeners()
  }

  setupListeners () {
    this.addEventListener('submit', this.handleSubmit.bind(this))
  }

  async handleSubmit (event) {
    event.preventDefault()

    const cartKey = this.els.input.element.dataset.cartKey

    await this.postCartAttribute(cartKey, true)

    this.isLocked = false
  }

  async postCartAttribute (key, value) {
    try {
      const response = await fetch('/cart/update.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          attributes: {
            [key]: value,
          },
        }),
      })

      if (!response.ok) {
        throw new Error('Network response was not ok')
      }
    } catch (error) {
      console.error('Failed to update cart attribute:', error)
    }
  }

  get isLocked () {
    return this.state.isLocked
  }

  set isLocked (value) {
    this.state.isLocked = value

    if (!value) {
      this.submit()
    }
  }
}

customElements.define('locked-collection-form', LockedCollectionForm, {
  extends: 'form',
})
